const permissionKeys = {
  general: {
    dashboard: 'Dashbaord',
    alumniStory: 'Alumni Story',
    walkInEnquiry: 'Walk In Enquiry',
    onlineEnquiry: 'Online Enquiry',
    qontakEnquiry: 'Qontak Enquiry',
    registrationEnquiry: 'Registration Enquiry',
    corporateEnquiry: 'Corporate Enquiry',
    talentPool: 'Talent Pool',
    freeCourseFollowUp: 'Free Course Follow-Up',
    infoSessionFollowUp: 'Info Session Follow-Up',
  },
  program: {
    root: 'Program',
    syllabus: 'Program Syllabus',
  },
  videoLearning: {
    root: 'Video Learning',
    access: 'Video Learning Access',
    practiceSession: 'Video Learning Practice Session',
    studentQuestion: 'Video Learning Student Question',
    bundles: 'Video Learning Bundle',
  },
  livestream: {
    root: 'Livestream',
    access: 'Livestream Access',
    schedule: 'Livestream Schedule',
  },
  cost: {
    root: 'Program Cost',
    categories: 'Program Cost Categories',
  },
  exam: {
    root: 'Exam',
    schedulesTranscript: 'Exam Schedules & Transcript',
  },
  evaluation: {
    root: 'Evaluation',
    lecturer: 'Lecturer Evaluation',
  },
  digitalSignature: {
    root: 'Digital Signature Document',
  },
  scholarship: {
    root: 'Scholarship',
  },
  paylater: { root: 'Paylater' },
  academicSchedule: { root: 'Academic Schedule' },
  communityPartner: { root: 'Community Partner' },
  finance: {
    purchaseOrder: 'Purchase Order',
    eFaktur: 'EFaktur',
    transactionInstallment: 'Transaction Installment',
  },
  promotion: {
    voucherCode: 'Vouchers Code',
    promo: 'Promo',
    promoPopUp: 'Promo Pop Up',
  },
  report: {
    salesReport: 'Sales Report',
    programSalesReport: 'Program Sales Report',
    installmentReport: 'Installment Report',
    installmentARReport: 'Installment AR Report',
    newInstallmentReport: 'New Installment Report',
    suspendedInstallmentReport: 'Suspended Installment Report',
  },
  user: {
    root: 'User',
    role: 'User Role',
  },
  student: {
    info: 'Student Info',
    report: 'Student Report',
    announcement: 'Student Announcement',
    birthday: 'Student Birthday',
    support: 'Student Support',
    attendees: 'Student Attendees',
    recommendation: 'Student Recommendation',
  },
  lecturer: {
    root: 'Lecturer',
  },
  operational: {
    root: 'Operational',
  },
  community: {
    benefit: 'Community Benefit',
    pacMember: 'Community PAC Member',
    tribe: 'Community Tribe',
    activity: 'Community Activity',
    jobPosting: 'Community Job Posting',
    studentJobPostAccess: 'Community Student Job Post Access',
    alumni: 'Community Alumni',
    firstRecruitment: 'Community Alumni First Recruitment',
    company: 'Community Company',
    alumniContact: 'Community Alumni Contact',
  },
  elearningHub: {
    youtubePlaylists: 'Youtube Playlists',
    youtubeVideos: 'Youtube Videos',
  },
  notification: {
    root: 'Notification',
  },
  grade: {
    root: 'Grade List',
    batch: 'Grade Batch List',
  },
  support: {
    root: 'Support Ticket',
  },
  admission: {
    root: 'Admission',
  },
};

export default permissionKeys;
